import React from 'react';
import { connect } from 'react-redux';
import ErrorPage from '../../containers/ErrorPage';
import BasePage from '../../baseClasses/BasePage';
import Header from '../../components/Header';
import Home from '../../containers/Home';
import animator from '../../helpers/animator';
import TabbedPageControl from '../../components/TabbedPageControl';
import './ManagerDashboard.scss';
import dataModel from '../../models/DataModel';

import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import ActivityLog from './ActivityLog';
import ProjectReport from './ProjectReport';
import InsightsDashboard from './InsightsDashboard';
import { userHasInsightsOnlyRole } from '../../helpers/user/insightsRoleAccess';
// import ProjectAnalysis from './ProjectAnalysis'
// import UserReport from './UserReport'

export class ManagerDashboard extends BasePage {

  constructor(props) {
    super(props);

    this.animator = new animator();
    this.firstTime = true;
    this.animateIn = true;
    
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    
    this.ensureTabs(props, false);
    this.tabNameToAnalyticsEvent = new Map([
      ['dashboard', 'DashboardClicked'],
      ['project reporting', 'ProjectReportingClicked'],
      ['activity log', 'ActivityLogClicked'],
    ]);
  }

  componentDidMount() {
    super.componentDidMount();
    this.firstTime = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentCompany) {
      if (!prevProps.currentCompany || (prevProps.currentCompany.id != this.props.currentCompany.id)) {
        this.ensureTabs(this.props, true);
      }
      else if (prevProps.currentUser != this.props.currentUser) {
        this.ensureTabs(this.props, true);
      }
    }
  }

  ensureTabs(props, isUpdate) {
    const { currentUser } = props;
    if (currentUser) {
      if (userHasInsightsOnlyRole(currentUser)) {
        this.tabs = ['dashboard'];
        if (isUpdate) {
          this.setState({
            selectedTabName: 'dashboard',
            goToFilteredState: null,
          });
        }
        else {
          this.state = {
            selectedTabName: 'dashboard',
            goToFilteredState: null,
          };
        }
        return;
      }
      if (currentUser.isVendorUser) {
        this.tabs = ['dashboard', 'project reporting'];
        if (isUpdate) {
          this.setState({
            selectedTabName: 'dashboard',
            goToFilteredState: null,
          });
        }
        else {
          this.state = {
            selectedTabName: 'dashboard',
            goToFilteredState: null,
          };
        }
      }
      else {
        if (this.props.currentUser.role.name == 'editor') {
          this.tabs = ['dashboard', 'project reporting'];
        }
        else {
          this.tabs = ['dashboard', 'project reporting', 'activity log'];
        }
        if (isUpdate) {
          this.setState({
            selectedTabName: 'dashboard',
            sortField: { fieldName: 'project_name', ascending: true },
            goToFilteredState: null,
          });
        }
        else {
          this.state = {
            selectedTabName: 'dashboard',
            sortField: { fieldName: 'project_name', ascending: true },
            goToFilteredState: null,
          };
        }
      }
    }
  }

  async handleGoToProjectFiltered(filter) {
    await this.setState({ goToFilteredState: filter });
    this.switchToTab('project reporting');
  }

  getSystemPopupView() {
    if (this.props.systemPopup) {
      return this.props.systemPopup;
    }
    else {
      return null;
    }
  }

  handleTabClick(tabName) {    
    if (this.tabNameToAnalyticsEvent.has(tabName)) {
      this.analyticsLogger.logManagerDashboardEvent(this.tabNameToAnalyticsEvent.get(tabName));
    }
    this.switchToTab(tabName);
  }

  switchToTab(tabName) {
    this.viewKey = Math.floor(Math.random() * 100);
    this.setState({ selectedTabName: tabName }, () => {
      this.setState({ goToFilteredState: null });
    });
  }

  render() {
    const { selectedTabName } = this.state;
    if (this.props.catastrophicError) {
      return <ErrorPage catastrophicError={this.props.catastrophicError} />;
    }

    let waitSpinner = null;
    if (this.props.inProgress) {
      waitSpinner = <Home type="transparent" />;
    }

    this.setWhiteLabels(this.props.currentCompany);

    const systemPopup = this.getSystemPopupView();

    let tabbedView = null;
    let selectedTabPath = selectedTabName;
    if (this.props.location && this.props.location.pathname) {
      const pathMatch = this.props.location.pathname.match(/\/([^/]+)(\/*)?$/);
      if (pathMatch && pathMatch[1]) {
        selectedTabPath = pathMatch[1].replace(/manager-/g, '').replace(/-/g, ' ');
      }
    }
    switch (selectedTabPath ? selectedTabPath : selectedTabName) {
        case "dashboard":
          tabbedView = <InsightsDashboard key={this.viewKey} />
          break
        case "project reporting":
          tabbedView = <ProjectReport
            key={this.viewKey}
            goToFilteredState={this.state.goToFilteredState}
          />
          break
      // case "user reporting":
      //   tabbedView = <UserReport
      //     key={this.viewKey}
      //     handleLogExport={this.handleLogExport}
      //   />
      //   break
    case 'activity log':
      tabbedView = <ActivityLog
          key={this.viewKey}
          handleLogExport={this.handleLogExport}
        />;
      break;
    default:
      break;
    }

    return (
      <div className="manager-dashboard"
        ref={(element) => { this.mainContainer = element; }}>
        {systemPopup}
        {waitSpinner}
        <Header companies={this.props.companies} selectedPage="manager-dashboard" />
        <div className={'dashboard-body' + (this.tabs && this.tabs.length === 1 ? ' dashboard-body--single-dashboard-tab' : '')}>
          <div className="tabs-container">
            {this.tabs && this.tabs.length > 1 ? (
              <TabbedPageControl 
                tabItems={this.tabs} 
                selectedTabName={selectedTabName}
                handleClick={this.handleTabClick}
                selectedTabPath={selectedTabPath}
              />
            ) : null}
          </div>
          <div className="tabbed-view-container">
            {tabbedView}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    catastrophicError: state.main.catastrophicError,
    inProgress: state.main.inProgress,
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps)(ManagerDashboard);



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/index.js